import { render, staticRenderFns } from "./GestionConfigurationBien.vue?vue&type=template&id=25945fc3&scoped=true&"
import script from "./GestionConfigurationBien.vue?vue&type=script&lang=js&"
export * from "./GestionConfigurationBien.vue?vue&type=script&lang=js&"
import style0 from "./GestionConfigurationBien.vue?vue&type=style&index=0&id=25945fc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25945fc3",
  null
  
)

export default component.exports